import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import CustomButton from "../CustomButton";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CustomDropzone from "../CustomDropzone";
import styles from "./UploadDropzone.module.css";
import dz from "../../assets/drop_your_file.png";
import { showToast } from "../../utils/toastUtils";
import { uploadPaperVersion } from "../../api/Api";
import { PAPER_FORMAT } from "../../constants/constant";

function AddPaperVersion({ show, handleClose, paperId, refresh }) {
  const [uploadData, setUploadData] = useState(null);

  const handleUpload = async (values) => {
    if (!uploadData) {
      showToast("Please upload a file before proceeding.", "error");
      return;
    }

    const payload = {
      file_name: uploadData.file_name,
      paper_id: paperId,
      file_id: uploadData.file_hash,
      file_size: uploadData.file_size,
    };

    // upload paper version data to the server
    uploadPaperVersion(paperId, payload)
      .then((response) => {
        if (response.status === 201) {
          showToast("Paper version uploaded successfully", "success");
          handleClose();
          refresh();
        } else {
          showToast(response.data.message, "error");
          console.error("Error uploading data:", response);
        }
      })
      .catch((error) => {
        console.error("Upload failed:", error);
      });
  }


  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header style={{ borderBottom: 0 }} closeButton></Modal.Header>
      <Modal.Body className="d-flex justify-content-center">
        <CustomDropzone
          className={`${styles.dropzone}`}
          setUploadData={setUploadData}
          initUrl={`${process.env.REACT_APP_BACKEND_BASE_URL}/papers/upload/`}
          method="POST"
          destroyDep={[]}
          acceptedFiles={PAPER_FORMAT}
          children={
            <img
              src={dz}
              alt="Drop your file here"
              className={styles.innerImage}
            />
          }
        />
      </Modal.Body>
      <Modal.Footer
        className="justify-content-center border-0 "
        style={{ marginBottom: "30px" }}
      >
        <CustomButton onClick={handleUpload}>
          <FileUploadOutlinedIcon /> Upload File
        </CustomButton>
      </Modal.Footer>
    </Modal>
  );
}

export default AddPaperVersion;
